import * as React from 'react';
import { Bem } from '../../utils/css.js';
import '../../constants.js';
import { useId } from '../../utils/hooks/useId.js';
import './HeaderTime.scss.js';

const bem = Bem.create("vai-header-time");
const HeaderTime = (props) => {
  const id = useId(props.htmlId, ["header time"]);
  let timeDetails = null;
  if (props.details) {
    const anotherDetail = props.details[1] || String.fromCharCode(160);
    timeDetails = /* @__PURE__ */ React.createElement("span", null, props.details[0], /* @__PURE__ */ React.createElement("br", null), anotherDetail);
  }
  return /* @__PURE__ */ React.createElement("div", {
    id: id.toString(),
    "data-ta": props.dataTa,
    className: bem.block()
  }, /* @__PURE__ */ React.createElement("div", {
    id: id.copyWith(["time"]).toString(),
    className: bem.element("value")()
  }, props.time), /* @__PURE__ */ React.createElement("div", {
    id: id.copyWith(["details"]).toString(),
    className: bem.element("details")()
  }, timeDetails));
};

export { HeaderTime };
